import React from "react";
import Reveal from "./reveal";

/** Numbered card. `index` is 0-based; shows 01, 02 ... */
export default function FeatureCard({ index = 0, title, text, delay = 0 }) {
  return (
    <Reveal className="card card--hover feature-card" delay={delay}>
      <span className="num">{String(index + 1).padStart(2, "0")}</span>
      <h3>{title}</h3>
      {text && <p>{text}</p>}
    </Reveal>
  );
}
